<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

defineProps<{ product: ProductDocument }>();
</script>

<template>
  <div class="flex items-center gap-1 text-lg font-semibold text-primary">
    <template v-if="product.pre_order">
      <span class="i-local-arrow-right size-6" />
      {{ product.pre_order_timestamp ? `Disponible le ${datetime(product.pre_order_timestamp)}` : 'En précommande' }}
    </template>
    <template v-else-if="product.in_stock">
      <span class="i-local-check size-6" />
      En stock
    </template>
    <template v-else>
      <span class="i-local-x size-6" />
      Rupture de stock
    </template>
  </div>
</template>
